export default __webpack_public_path__ + "static/media/kidcoBeer@2x.8692b610.jpg";